import React, { useState, useEffect } from "react";
import { LoadingPage as PageType } from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  onNext: () => void;
}

const LoadingPage: React.FC<Props> = ({ page, onNext }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    // Rotate messages
    const messageInterval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % page.messages.length);
    }, page.duration / page.messages.length);

    // Auto-advance after duration
    if (page.autoAdvance) {
      const timeout = setTimeout(() => {
        onNext();
      }, page.duration);

      return () => {
        clearTimeout(timeout);
        clearInterval(messageInterval);
      };
    }

    return () => clearInterval(messageInterval);
  }, [page, onNext]);

  return (
    <div className="page page--loading">
      <div className="page__container">
        <div className="loading">
          <div className="loading__spinner"></div>
          <p className="loading__message">{page.messages[messageIndex]}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
